var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useStorage } from 'master-hook';
import { registerError, purge } from '../use-app/actions';
import { refreshTokensAndRepeat } from './refresh-tokens-and-repeat';
import { STORAGE_NAME as appStorageName } from '../use-app';
import { __prod__ } from '../constants';
import { makeRequest } from './make-request';
/**
 * Fetch data from IOMART server
 * @param options HTTP request options
 * @param stub Fake responce
 * @returns `undefined` if error, responce body if success
 */
export var fetch = function (options, stub) { return __awaiter(void 0, void 0, void 0, function () {
    /* Helpers */
    function errorHandler(error, title, code) {
        var _a;
        registerError({
            code: code || ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) + 1000,
            title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u043F\u0440\u043E\u0441\u0430: ".concat(title || (error === null || error === void 0 ? void 0 : error.message)),
            text: "\u0417\u0430\u043F\u0440\u043E\u0441: ".concat(JSON.stringify(options), "\n\u041E\u0442\u0432\u0435\u0442: ").concat(JSON.stringify(error === null || error === void 0 ? void 0 : error.response)),
            more: options,
            source: 'iomart-hooks/utils/fetch',
        });
    }
    var useStubs, applyStubs, delay;
    return __generator(this, function (_a) {
        if (!options) {
            return [2 /*return*/];
        }
        useStubs = useStorage(appStorageName).useStubs;
        applyStubs = !__prod__ && useStubs && stub && !stub.isDebugOff === true;
        if (applyStubs) {
            delay = (stub === null || stub === void 0 ? void 0 : stub.time) || 500;
            return [2 /*return*/, (stub === null || stub === void 0 ? void 0 : stub.result) === "ERROR"
                    ? setTimeout(function () { return errorHandler(stub === null || stub === void 0 ? void 0 : stub.error); }, delay)
                    : setTimeout(function () { return stub === null || stub === void 0 ? void 0 : stub.data; }, delay)];
        }
        // Making request
        return [2 /*return*/, makeRequest(options, undefined)
                .then(function (result) {
                var _a, _b;
                if ((_a = result === null || result === void 0 ? void 0 : result.errors) === null || _a === void 0 ? void 0 : _a.find(function (error) { return error.message.includes('relogin_start'); })) {
                    return refreshTokensAndRepeat(options);
                }
                if ((_b = result === null || result === void 0 ? void 0 : result.errors) === null || _b === void 0 ? void 0 : _b.find(function (error) { return error.message.includes('no_session'); })) {
                    purge();
                }
                return result;
            })
                .catch(function (error) {
                var _a, _b, _c;
                errorHandler(error);
                var data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
                var errors = Array.isArray(data === null || data === void 0 ? void 0 : data.errors) ? data.errors : (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.errors;
                if (Array.isArray(errors) && errors.length > 0) {
                    var err = new Error((error === null || error === void 0 ? void 0 : error.message) || 'Request failed');
                    err.errors = errors;
                    err.data = (_c = data === null || data === void 0 ? void 0 : data.data) !== null && _c !== void 0 ? _c : null;
                    throw err;
                }
                throw error;
            })];
    });
}); };
